import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { UiTabsModule } from '@cigna/ui/tabs';
import { AnalyticsUiModule } from '@cigna/analytics/ui';
import { UiButtonModule } from '@cigna/ui/button';
import { UiIconModule } from '@cigna/ui/icon';
import { UiInputModule } from '@cigna/ui/input';

import { ChcpRoutes } from '@cigna/chcp/shared/util';
import { ChcpSharedUiModule } from '@cigna/chcp/shared/ui';
import { ChcpPatientSharedDataAccessModule } from '@cigna/chcp/patient/shared/data-access';
import { ChcpShellUiModule } from '@cigna/chcp/shell/ui';

import { PatientComponent } from './patient/patient.component';
import { PrecertificationComponent } from './precertification/precert.component';
import { ChcpSharedEnvironmentUtilModule } from '@cigna/chcp/shared/environment-util';

const routes: ChcpRoutes = [
  {
    path: '',
    component: PatientComponent,
    children: [
      {
        path: '',
        redirectTo: 'search',
        pathMatch: 'full',
      },
      {
        path: 'search',
        loadChildren: () =>
          import('@cigna/chcp/patient/search-feature').then(
            (m) => m.ChcpPatientSearchFeatureModule,
          ),
        data: {
          breadcrumb: 'search',
          title: 'Patient Search',
          analytics: {
            name: 'Patient Search',
            section: 'Patients',
            prop13: 'pv-PS003-Patients View',
          },
        },
      },
      {
        path: 'results',
        loadChildren: () =>
          import('@cigna/chcp/patient/results-feature').then(
            (m) => m.ChcpPatientResultsFeatureModule,
          ),
        data: {
          breadcrumb: 'results',
          title: 'Patient Results',
          analytics: {
            name: 'Search Results',
            section: 'Patients',
            prop13: 'pv-PS003-Patients View',
          },
        },
      },
      {
        path: 'detail/:id',
        loadChildren: () =>
          import('@cigna/chcp/patient/details-feature').then(
            (m) => m.ChcpPatientDetailsFeatureModule,
          ),
        data: {
          breadcrumb: 'details',
          title: 'Patient Details',
          bluebar: true,
        },
      },
      {
        path: 'precertsubmit',
        component: PrecertificationComponent,
        data: {
          title: 'View and Submit Certifications',
          analytics: {
            name: 'Certifications',
            section: 'Patients',
            prop13: 'pv-New Page',
          },
        },
      },

      {
        path: 'precertification',
        loadChildren: () =>
          import('@cigna/chcp/patient/precertification-feature').then(
            (m) => m.ChcpPatientPrecertificationFeatureModule,
          ),
      },
      {
        path: '**',
        redirectTo: 'search',
      },
    ],
  },
];

@NgModule({
  imports: [
    UiTabsModule,
    AnalyticsUiModule,
    ChcpSharedUiModule,
    CommonModule,
    UiIconModule,
    ChcpShellUiModule,
    ChcpPatientSharedDataAccessModule,
    UiButtonModule,
    UiInputModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    RouterModule.forChild(routes),
    TranslateModule,
    ChcpSharedEnvironmentUtilModule,
  ],
  declarations: [PatientComponent, PrecertificationComponent],
})
export class ChcpPatientShellFeatureModule {}
